
import './modernizr.js'; // 'npm run modernizr' to create this file

import '../node_modules/ika.jvectormap/jquery-jvectormap-1.2.2.min.js';
import '../node_modules/ika.jvectormap/jquery-jvectormap-world-mill-en.js';
import '../node_modules/ika.jvectormap/jquery-jvectormap-us-mill-en.js';

import '../node_modules/jquery-slimscroll/jquery.slimscroll.js';

